import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=86b92e8c&lang=pug&"
import script from "./Referencias.vue?vue&type=script&lang=js&"
export * from "./Referencias.vue?vue&type=script&lang=js&"
import style0 from "./Referencias.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports